export default {
    //prop检索
    propSearch: "/v2/es/prop/search",
    // 新增检索
    getPropSearch:"/v2/es/prop/searchByAccount",
    //unit检索
    unitSearch: "/propertyManagement/unit/search",
    // bank检索
    bank: "/propertyManagement/bank/search",
    // Proprety table数据
    showProperty: "/propertyManagement/prop/show",
    // Proprety  根据ID请求点位详情
    getPropertyId: "/propertyManagement/prop/getById",
    //property add property 新增
    getPropertyAdd:"/propertyManagement/prop/add",
    // state 字典查询
    getStateDict:"/propertyManagement/prop/getStateDict",
    // propType
    getPropTypeDict:"/propertyManagement/prop/getPropTypeDict",
    // Bank 列表查询
    getBankList:"/propertyManagement/bank/show",
    // bank 新增
    getBankAdd:"/propertyManagement/bank/add",
    // bank 修改
    getBankEdit:"/propertyManagement/bank/update",
    // bank 删除
    getBankDelete:"/propertyManagement/bank/deleteByBankId",
    // bank 导出Excel
    getBankExcel:"/propertyManagement/bank/export",
    // bank 导出单条PDF
    getBankPDFById:"/propertyManagement/bank/exportPdf",
    // bank 导出TXT
    getBankByTxt:"/propertyManagement/bank/exportTxt",
    // bank 文件上传
    getBankUpload:"/propertyManagement/bank/uploadFile",
    // bank 根据ID查询详情
    getBankById:"/propertyManagement/bank/showBankId",
    // bank 根据ID 查看文件
    getBankByFile:"/propertyManagement/bank/getBankFile",
    // bank 删除附件
    getDeleFile:"/propertyManagement/bank/delFiles",
    // bank 修改 - 新增附件
    getAddUploadFile:"/propertyManagement/bank/addUploadFile",
    // bank -GL 下拉框
     getBankGLById:"/propertyManagement/bank/showGlAcctById",
    // 根据Trust 查询相关
    getBankByTrust:"/propertyManagement/bank/banksByTrustId",
    // Trust 列表查询
    getTrustData:"/propertyManagement/trust/show",
    //  Trust 新增
    getTrustAdd:"/propertyManagement/trust/add",
    //  Trust 修改
    getTrustEdit:"/propertyManagement/trust/update",
    //  Trust 删除
    getTrustDelete:"/propertyManagement/trust/delete",
    //  Trust 下载
    getTrustExcel:"/propertyManagement/trust/delete",
    //  Trust  单个回显
    getTrustByIdData:"/propertyManagement/trust/trustById",
    // Owner 列表
    getOwnerTableList:'/propertyManagement/owner/show',
    // Owner 新增
    getOwnerAdd:"/propertyManagement/owner/add",
    // Owner 修改
    getOwnerEdit:"/propertyManagement/owner/update",
    // Owner 删除
    getOwnerDelete:"/propertyManagement/owner/delete",
    //  Owener 回显
    getOwnerById:"/propertyManagement/owner/ownerById",
    // Owner 下载
    getOwnerExcel:"/propertyManagement/owner/export",
    // Group  列表
    getGropTableList:"/propertyManagement/group/show",
    // Group 新增
    getGroupAdd:"/propertyManagement/group/add",
    // Group 修改
    getGroupUpdate:"/propertyManagement/group/update",
    // 修改回显
    getGroupById:"/propertyManagement/group/showById",
    // Supervisor下拉框显示
    getGroupBySupervisor:"/propertyManagement/group/groupSupervisor",
    // Company 列表数据
    getCompanyTableList:"/propertyManagement/company/show",
    // Company 新增
    getCompanyAdd:"/propertyManagement/company/add",
    // Company 删除
    getCompanyDelete:"/propertyManagement/company/delete",
    // Company 根据ID查询回显
    getCompanyById:"/propertyManagement/company/showById",
    // Company 修改
    getCompanyUpdate:"/propertyManagement/company/update",
    // Company 下载
    getCompanyExcel:"/propertyManagement/company/export",
    // trust下拉框数据
    getTrustListDict:"/propertyManagement/trust/trustList",

    // company 下拉列表
    getCompanyListDict:"/propertyManagement/company/companyList",
    // groupList 下拉列表
    getGroupListDict:"/propertyManagement/group/groupList",
    // city 下拉框
    getPropCityDict:"/common/getPropCity",
    // property --info update
    getPropInfoUpdate:"/propertyManagement/prop/propInfoUpdate",
    // property -- prop Move
    getPropMove:"/propertyManagement/prop/propMove",
    // getPropByTrustBank  --获取关联数据
    getPropByTrustBankDict:"/propertyManagement/prop/propByTrustBank",
    // property --修改
    getProperUpdateAll:"/propertyManagement/prop/updateAll",
    // property by id  修改获取详情
    getProperByIdDetail:"/propertyManagement/prop/getByProp",

    // 获取更换trust 预览，
    getChangeTrustResult:"/propertyManagement/prop/getChangeTrustResult",
    // prop 更换trust
    getPropChangeTrust:"/propertyManagement/prop/changeTrust",
    // 修改updateBalance
    getBankUpdateBalance:"/propertyManagement/bank/updateBalance",
};
